import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "w-10 mx-auto mt-8 border-gray-400 border-1 2xl:hidden" }, null, -1)
const _hoisted_3 = { class: "flex flex-col items-center gap-12 p-8 md:grid md:grid-cols-2 md:items-start lg:grid-cols-3 xl:grid-cols-4 2xl:flex 2xl:items-center 2xl:flex-wrap 2xl:h-screen" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Nenhum produto para exibir.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_ProductTable = _resolveComponent("ProductTable")!
  const _component_View = _resolveComponent("View")!

  return (_ctx.products.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "slide-up",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Logo, { class: "mt-8 2xl:hidden" })
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_Transition, {
          name: "fade-in",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createBlock(_component_ProductTable, {
                  key: product.id,
                  product: product,
                  class: "w-full 2xl:w-60"
                }, null, 8, ["product"]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_View, {
        key: 1,
        "secondary-text": "Cadastre novos produtos através do aplicativo."
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }))
}